export const enum TrainingEnvironment {
    Gym = "gym",
    Home = "home",
    Mix = "mix",
}

export const enum GymType {
    Large = "large",
    Small = "small",
    Garage = "garage",
    Home = "home",
}

export const enum Equipment {
    PullUps = "pullups",
    JumpRope = "jumpRope",
    Kettlebell = "kettlebell",
    Barbell = "barbell",
    Dumbbells = "dumbbells",
    PowerBand = "powerBand",
    SwissBall = "swissball",
    WheelRoll = "wheelroll",
    Roller = "roller",
    LoopBand = "loopBand",
    YogaMat = "yogaMat",
    PlyoBox = "plyoBox",
    Bench = "bench",
    LowerBackBench = "lowerBackB",
    ChestPress = "chestPress",
    CrossoverCableMachine = "crossCabM",
    LegPress = "legPress",
    EzBar = "ezBar",
    LatMachine = "latMachine",
    LegCurlMachine = "legCurlMac",
    TrapBar = "trapBar",
    Landmine = "landmine",
    Rack = "rack",
    PulleyMachine = "pulleyMach",
    LegExtension = "legExte",
    InclineBench = "inclBench",
}
